var _g, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSidebarIconLargeActive = function SvgSidebarIconLargeActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 56.25,
    viewBox: "0 0 100 56.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White_Box",
    "data-name": "White Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M685.032,535.343h-99v-55.25h99Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M586.532,480.592v54.25h98v-54.25h-98m-1-1h100v56.25h-100Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box",
    "data-name": "Grey Box",
    d: "M588.532,482.592h70.6v49.25h-70.6Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-2",
    "data-name": "Grey Box-2",
    d: "M661.132,482.592h21.335v14.989H661.132Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-3",
    "data-name": "Grey Box-3",
    d: "M661.132,499.723h21.335v14.989H661.132Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Grey_Box-4",
    "data-name": "Grey Box-4",
    d: "M661.132,516.852h21.335v14.989H661.132Z",
    transform: "translate(-585.532 -479.592)",
    fill: "#024"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSidebarIconLargeActive);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iR3JvdXBfNTIiIGRhdGEtbmFtZT0iR3JvdXAgNTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSI1Ni4yNSIgdmlld0JveD0iMCAwIDEwMCA1Ni4yNSI+CiAgPGcgaWQ9IldoaXRlX0JveCIgZGF0YS1uYW1lPSJXaGl0ZSBCb3giPgogICAgPHBhdGggaWQ9IlBhdGhfMSIgZGF0YS1uYW1lPSJQYXRoIDEiIGQ9Ik02ODUuMDMyLDUzNS4zNDNoLTk5di01NS4yNWg5OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODUuNTMyIC00NzkuNTkyKSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfMiIgZGF0YS1uYW1lPSJQYXRoIDIiIGQ9Ik01ODYuNTMyLDQ4MC41OTJ2NTQuMjVoOTh2LTU0LjI1aC05OG0tMS0xaDEwMHY1Ni4yNWgtMTAwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU4NS41MzIgLTQ3OS41OTIpIiBmaWxsPSIjMDI0Ii8+CiAgPC9nPgogIDxwYXRoIGlkPSJHcmV5X0JveCIgZGF0YS1uYW1lPSJHcmV5IEJveCIgZD0iTTU4OC41MzIsNDgyLjU5Mmg3MC42djQ5LjI1aC03MC42WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU4NS41MzIgLTQ3OS41OTIpIiBmaWxsPSIjMDI0Ii8+CiAgPHBhdGggaWQ9IkdyZXlfQm94LTIiIGRhdGEtbmFtZT0iR3JleSBCb3gtMiIgZD0iTTY2MS4xMzIsNDgyLjU5MmgyMS4zMzV2MTQuOTg5SDY2MS4xMzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg1LjUzMiAtNDc5LjU5MikiIGZpbGw9IiMwMjQiLz4KICA8cGF0aCBpZD0iR3JleV9Cb3gtMyIgZGF0YS1uYW1lPSJHcmV5IEJveC0zIiBkPSJNNjYxLjEzMiw0OTkuNzIzaDIxLjMzNXYxNC45ODlINjYxLjEzMloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODUuNTMyIC00NzkuNTkyKSIgZmlsbD0iIzAyNCIvPgogIDxwYXRoIGlkPSJHcmV5X0JveC00IiBkYXRhLW5hbWU9IkdyZXkgQm94LTQiIGQ9Ik02NjEuMTMyLDUxNi44NTJoMjEuMzM1djE0Ljk4OUg2NjEuMTMyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTU4NS41MzIgLTQ3OS41OTIpIiBmaWxsPSIjMDI0Ii8+Cjwvc3ZnPgo=";